/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    width: PropTypes.oneOf(['xs', 's', 'm', 'l', 'xl']),
};

const defaultProps = {
    ...commonDefaultProps,
    width: 'm',
};

const ModalContent = (props) => {
    const classNames = [
        'c-modal__container',
        `c-modal__container--${props.width}`,
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

ModalContent.propTypes = propTypes;

ModalContent.defaultProps = defaultProps;

export default ModalContent;
